// Add your custom JS here.
( function( $ ) {

    AOS.init();



    // HEADER SCROLL FUNCTIONS
    $(document).scroll(function(){
        if($(this).scrollTop() > 50)
        {   
            $('#wrapper-navbar').addClass('off-top');

        }
        if($(this).scrollTop() < 50)
        {   
            $('#wrapper-navbar').removeClass('off-top');
            $(".menu a").removeClass('active');
        }
    });

    var lastScrollTop = 0;
    $(window).scroll(function(event){
        var st = $(this).scrollTop();
        if (st > lastScrollTop){
            $('#wrapper-navbar').addClass('hide');
        } else {
            $('#wrapper-navbar').removeClass('hide');
        }
        lastScrollTop = st;
    });
    

    
    // TESTIMONIAL SWIPER
    $(".testi-img:first-of-type").addClass("active");

    var testimonialSwiper = new Swiper(".testimonial-swiper", {
        slidesPerView: 1,
        spaceBetween: 24,
        speed: 300,
        navigation: {
            nextEl: ".testimonial-next",
            prevEl: ".testimonial-prev",
        },
        on: {
            slideChange: function () {
                var activeIndex = this.activeIndex + 1;
                $(".testi-img.active").removeClass("active");
                $(".testi-img-" + activeIndex + "").addClass("active");
            }
        }
    });


    // BRAND POSITIONING
    var childCount = $(".brand").length;
    var angle = 360 / childCount;
    $(".brand").each(function (index) {
        var rotation = angle * index;
        $(this).css("transform", "rotate(" + rotation + "deg)");
    });

    $(".brand-inner").each(function (index) {
        var rotation = angle * index;
        $(this).css("transform", "rotate(-" + rotation + "deg)");
    });



    // MOBILE MENU TOGGLE
    $('.header-toggle').on("click", function () {
        $("#wrapper-navbar").toggleClass("active");
    });



    // VACANCY FILTER TOGGLE
    $('.filter-toggle').on("click", function () {
        $(".section-one form, .section-two .filter, .filter-backdrop").addClass("active");
    });

    $('.filter-backdrop').on("click", function () {
        $(".section-one form, .section-two .filter, .filter-backdrop").removeClass("active");
    });



    // JOB ALERT TOGGLE
    $('a[href*="#jobalert"]').on("click", function () {
        $(".job-alert-modal-outer").fadeIn(150);
    });

    $('.job-alert-modal-outer, .job-alert-modal-outer .top i').on('click', function(event) {
        if (event.target === this) {
            $(".job-alert-modal-outer").fadeOut(150);
        }
    });



    $('a[href*="#"]').on('click', function(e) {
        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $('html').css('scroll-behavior', 'auto');

                // Scroll to the target element
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Re-enable smooth scrolling after scrolling is complete
                    $('html').css('scroll-behavior', 'smooth');
                });
            }
        }
    });
    
    
    // PAGE TRANSITIONS
    $("a").click(function(event) {
        // Check if the anchor has a target attribute set to "_blank"
        if ($(this).attr("target") === "_blank") {
            return; // Do nothing if it has target="_blank"
        }

        // Check if the anchor has a "tel:" or "mailto:" href
        var href = $(this).attr("href");
        if (href.startsWith("tel:") || href.startsWith("mailto:")) {
            return; // Do nothing for tel: and mailto: links
        }

        // Check if the anchor has a "#" href
        if (href.indexOf('#') !== -1) {
            // Do nothing for "#" links, but allow them to work
            return;
        }

        // Prevent the default behavior of the anchor tag
        event.preventDefault();

        // Add the "active" class to the element with class "page-transition-in"
        $(".page-transition-in").addClass("active");

        // Delay navigation by 300 milliseconds
        setTimeout(function() {
            window.location.href = href;
        }, 300);
    });



    // PARALLAX EFFECTS
    if ($(window).width() > 992) {

        var image = document.getElementsByClassName('fast');
        new simpleParallax(image, {
            overflow: true,
            scale: 1.5
        });

        var image = document.getElementsByClassName('slow');
        new simpleParallax(image, {
            overflow: true,
            scale: 1.1
        });
    }

    var image = document.getElementsByClassName('middle-inline');
    new simpleParallax(image, {
        scale: 1.25
    });

    $(".img-wrapper:last-of-type").addClass("hor-left");
    $(".img-wrapper:first-of-type").addClass("hor-right");

    var image = document.getElementsByClassName('hor-right');
    new simpleParallax(image, {
        overflow: true,
        scale: 2,
        orientation: 'right'
    });

    var image = document.getElementsByClassName('hor-left');
    new simpleParallax(image, {
        overflow: true,
        scale: 2,
        orientation: 'left'
    });



    // SINGLE VACANCY DOM CHANGES
    $(".single-vacancy .toggle-item>p:first-of-type").prepend("<div class='button primary500'><i class='icon-plus'></i></div>").wrap("<div class='toggle'></div>");

    $('.single-vacancy .toggle-item').each(function() {
        $(this).find('.toggle').nextUntil('.toggle-item').wrapAll('<div class="info"></div>');
    });




    // VACANCY OVERVIEW DOM CHANGES
    $(".filter-option.Locations").append("<div class='showmore'><span>Toon meer</span><i class='icon-chevron-down'></i></div>");

    $(".filter-option.Locations .showmore").on("click", function () {
        if (!$(this).hasClass("active")) {
            $(".filter-option.Locations, .filter-option.Locations .showmore").addClass("active");
            $(".filter-option.Locations .showmore span").text("Toon minder");
        } else {
            $(".filter-option.Locations, .filter-option.Locations .showmore").removeClass("active");
            $(".filter-option.Locations .showmore span").text("Toon meer");
        }
    });



    // SINGLE VACANCY TOGGLES
    $(".toggle-item").on("click", function () {
        if (!$(this).hasClass("active")) {
            $(".toggle.active .info").slideUp(150);
            $(".toggle.active").removeClass("active");
            $(this).addClass("active");
            $(this).children(".info").slideDown(150);
        } else {
            $(this).removeClass("active");
            $(this).children(".info").slideUp(150);
        }
    });



    // PAGE TEMPLATE ABOUTPAGE
    if ($("body").hasClass("page-template-aboutpage")) {
        function checkElementPosition() {
            const middleOfViewport =
                $(window).scrollTop() + $(window).height() / 2;

            $(".value").each(function () {
                const elementMiddle =
                    $(this).offset().top + $(this).height() / 2;

                if (elementMiddle > middleOfViewport) {
                    $(this).addClass("active");
                } else {
                    $(this).removeClass("active");
                }
            });
        }

        // Add event listener for scrolling using jQuery
        $(window).scroll(checkElementPosition);

        // Initial check when the page loads
        checkElementPosition();

        $(".topbar-timeline-inner .dot:first-child").addClass("active");
        $(".topbar-timeline .title:first-child").addClass("active");

        // Get the height of the timeline section
        var timelineHeight = $(".timeline").height() - $(window).height();

        // Add a scroll event listener to the window
        $(window).scroll(function () {
            // Calculate how far you have scrolled past the timeline section
            var scrolled = $(window).scrollTop() - $(".timeline").offset().top;

            // Calculate the percentage scrolled
            var percentageScrolled = (scrolled / timelineHeight) * 100;

            // Update the width of the ".topbar-timeline-inner-fillup" element
            $(".topbar-timeline-inner-fillup").css(
                "width",
                percentageScrolled + "%"
            );
        });

        var timelineBlocks = $(".timeline-block .year");
        var currentIndex = 1;
        var prevIndex = 1;

        function updateIndex() {
            var middleOfViewport =
                $(window).scrollTop() + $(window).height() / 2;

            timelineBlocks.each(function (index) {
                var elementTop = $(this).offset().top;

                if (elementTop < middleOfViewport) {
                    currentIndex = index + 1;
                }
            });
        }

        $(window).scroll(function () {
            updateIndex();

            if (currentIndex !== prevIndex) {
                $(".topbar-timeline-inner .dot").removeClass("active");
                $(
                    ".topbar-timeline-inner .dot[dotindex='" +
                        currentIndex +
                        "']"
                ).addClass("active");

                $(".topbar-timeline .title.active")
                    .removeClass("active")
                    .fadeOut(150, function () {
                        $(
                            ".topbar-timeline .title[yearindex='" +
                                currentIndex +
                                "'"
                        )
                            .fadeIn(150)
                            .addClass("active");
                    });

                prevIndex = currentIndex;
            }
        });
    }



    // Function to remove the "active" class from "page-transition-in" element
    function removeActiveClass() {
        var element = document.querySelector('.page-transition-in');
        if (element) {
            element.classList.remove('active');
        }
    }

    // Execute the function on page load
    window.addEventListener('load', removeActiveClass);

    // Execute the function on pageshow event (including navigating back in Safari)
    window.addEventListener('pageshow', removeActiveClass);

    


    // FILTER FUNCTIONS
    $('.mobile-filter-button').on('click', function() {
        $('.sidebar').addClass('active');
        $('.mobile-show-results-button').addClass('active');
    });

    $('.mobile-close-cross, .mobile-show-results-button').on('click', function() {
        $('.sidebar').removeClass('active');
        $('.mobile-show-results-button').removeClass('active');
    });

    $('#textinput-searchbutton').on('click', function() {
        $('.sidebar').removeClass('active');
        $('.mobile-show-results-button').removeClass('active');
    });

    $('#textinput-searchfield').keypress(function (event) {
        if (event.keyCode === 10 || event.keyCode === 13) {
            event.preventDefault();
            $("#textinput-searchfield").blur(); 
        }
    });

    $('#textinput-searchbutton').on('click', function() {
        $("#textinput-searchfield").blur(); 
    });
 
    

    // HOME SEARCH
    // https://workandjoy.mediabirds.dev/vacatures-overzicht/?query=sales&locations[]=amsterdam


   

      



})(jQuery);
